import styled from 'vue3-styled-components';

// 모달 오버레이
export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`;

// 모달 컨테이너
export const ModalContent = styled.div`
    background: #ffffff;
    border-radius: 20px;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.2);
    width: 700px;
    max-width: 90vw;
    max-height: 85vh;
    overflow: hidden;
    animation: slideInUp 0.3s ease-out;
    
    @keyframes slideInUp {
        from {
            opacity: 0;
            transform: translateY(40px) scale(0.95);
        }
        to {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
    }
`;

// 모달 헤더
export const ModalHeader = styled.div`
    background: linear-gradient(135deg, #0f4c5c 0%, #1a6b7a 100%);
    padding: 24px 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: white;
`;

export const ModalTitle = styled.h2`
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    color: white;
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    color: white;
    font-size: 28px;
    cursor: pointer;
    padding: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    
    &:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: rotate(90deg);
    }
`;

// 모달 바디
export const ModalBody = styled.div`
    padding: 32px;
    max-height: 60vh;
    overflow-y: auto;
    
    /* 스크롤바 스타일링 */
    &::-webkit-scrollbar {
        width: 8px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 4px;
        
        &:hover {
            background: #a8a8a8;
        }
    }
`;

// 폼 컨테이너
export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

// 폼 행
export const FormRow = styled.div`
    display: flex;
    gap: 24px;
    
    @media (max-width: 768px) {
        flex-direction: column;
        gap: 20px;
    }
`;

// 폼 그룹
export const FormGroup = styled.div`
    flex: ${props => props.fullWidth ? '1' : '1 1 0'};
    min-width: 0;
`;

// 폼 라벨
export const FormLabel = styled.label`
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 14px;
    color: #374151;
    
    ${props => props.required && `
        &::after {
            content: ' *';
            color: #dc2626;
            font-weight: 700;
        }
    `}
`;

// 폼 입력 필드
export const FormInput = styled.input`
    width: 100%;
    padding: 14px 18px;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    font-size: 14px;
    background: #ffffff;
    transition: all 0.3s ease;
    box-sizing: border-box;
    
    &::placeholder {
        color: #9ca3af;
    }
    
    &:hover {
        border-color: #d1d5db;
        background: #fafbfc;
    }
    
    &:focus {
        outline: none;
        border-color: #0f4c5c;
        box-shadow: 0 0 0 4px rgba(15, 76, 92, 0.1);
        background: #ffffff;
    }
    
    &:invalid {
        border-color: #dc2626;
    }
`;

// 폼 선택 필드
export const FormSelect = styled.select`
    width: 100%;
    padding: 14px 18px;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    font-size: 14px;
    background: #ffffff;
    transition: all 0.3s ease;
    box-sizing: border-box;
    appearance: none;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e");
    background-position: right 16px center;
    background-repeat: no-repeat;
    background-size: 16px;
    padding-right: 48px;
    
    &:hover {
        border-color: #d1d5db;
        background-color: #fafbfc;
    }
    
    &:focus {
        outline: none;
        border-color: #0f4c5c;
        box-shadow: 0 0 0 4px rgba(15, 76, 92, 0.1);
        background-color: #ffffff;
    }
`;

// 폼 힌트
export const FormHint = styled.small`
    display: block;
    margin-top: 6px;
    font-size: 12px;
    color: #6b7280;
    font-style: italic;
`;

// 모달 푸터
export const ModalFooter = styled.div`
    background: #f9fafb;
    padding: 24px 32px;
    border-top: 1px solid #e5e7eb;
    display: flex;
    justify-content: flex-end;
    gap: 16px;
`;

// 버튼 공통 스타일
const ButtonBase = styled.button`
    padding: 12px 24px;
    border: none;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    
    &:hover {
        transform: translateY(-2px);
    }
    
    &:active {
        transform: translateY(0);
    }
`;

// 저장 버튼
export const SaveButton = styled(ButtonBase)`
    background: linear-gradient(135deg, #0f4c5c 0%, #0a3a47 100%);
    color: white;
    box-shadow: 0 4px 12px rgba(15, 76, 92, 0.3);
    
    &:hover {
        box-shadow: 0 6px 20px rgba(15, 76, 92, 0.4);
    }
`;

// 취소 버튼
export const CancelButton = styled(ButtonBase)`
    background: #f3f4f6;
    color: #374151;
    border: 2px solid #e5e7eb;
    
    &:hover {
        background: #e5e7eb;
        border-color: #d1d5db;
        color: #111827;
    }
`;

// 삭제 버튼
export const DeleteButton = styled(ButtonBase)`
    background: #dc2626;
    color: #ffffff;
    border: 2px solid #e5e7eb;
    
    &:hover {
        background: #dc2626;
        border-color: #d1d5db;
        color: #ffffff;
    }
`;